import { Box, Title, WizardStepRenderParams } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import ContactInfo from 'modules/finance/components/Contacts/ContactInfo'
import { FinanceContactsSelector } from 'modules/finance/components/Contacts/FinanceContactsSelector'
import type { WizardData } from 'modules/procurement/components/purchaseOrders/UpdateOrderModal/types'

const VendorStep: React.FC<WizardStepRenderParams<WizardData>> = ({ data, onDataChanged }) => {
  return (
    <Box gap="s24">
      <Title
        description={i18n.t(
          'procurement.purchase_orders.update_order_wizard.steps.vendor.description'
        )}
        title={i18n.t('procurement.purchase_orders.update_order_wizard.steps.vendor.title')}
      />
      <Box gap="s16" paddingRight="s24">
        <FinanceContactsSelector
          mandatory
          value={data.vendor}
          onSelect={(formVendorSelected) => {
            if (formVendorSelected && !!formVendorSelected.id) {
              onDataChanged({
                ...data,
                vendor: formVendorSelected,
              })
            }
          }}
          label={i18n.t('finance.vendors.vendor_form.fields.legal_name')}
          type="finance_contact"
          queryParams={{
            companyId: data.companyId,
            contactCreateType: 'vendor',
          }}
          variant={'gamma'}
        />
        {data.vendor && (
          <ContactInfo
            showTitle={false}
            contact={data.vendor}
            showLinkToEdit={false}
            as={'vendor'}
          />
        )}
      </Box>
    </Box>
  )
}

export default VendorStep
